import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IStyle,
} from 'office-ui-fabric-react';
import React, { useState } from 'react';
import { embedPwWebComponent, isElectron } from '../../../utils';
import connectLogo from '../../../assets/projectwise.svg';
import { AuthService } from '../../../services';
import {
  defaultFont,
  headerBarColor,
  primaryTextColor,
  themedText,
} from '../../../styles/SharedStyles';
import { LabeledToggle } from '../../Shared';
import { useThemeContext } from '../../../context';
import { ProjectInfo } from './ProjectInfo';
import { UserIconMenu } from './UserIconMenu';
import { Project } from '../../../types';
import { User } from 'oidc-client';

export interface HeaderBarProps {
  user: User;
  project: Project;
  onViewProfileClick: () => any;
  onProjectClick: () => any;
  onSignoutClick: () => Promise<void>;
  serviceName?: string;
  tabIsDefault: boolean;
  onSetDefaultConnection: (value: boolean) => any;
}

export function HeaderBar({
  user,
  project,
  onViewProfileClick,
  onProjectClick,
  onSignoutClick,
  serviceName,
  tabIsDefault,
  onSetDefaultConnection,
}: HeaderBarProps): JSX.Element {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [showUserMenu, setShowUserMenu] = useState<boolean>(false);

  const theme = useThemeContext();

  return (
    <div
      style={{
        font: 'Open Sans',
        position: 'relative',
        top: 0,
        height: '42px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        color: primaryTextColor(theme),
        background: `${headerBarColor(theme)}`,
      }}
    >
      <div
        onClick={onProjectClick}
        style={{
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          cursor: 'pointer',
          marginLeft: '5px',
          marginRight: '10px',
        }}
      >
        <img src={connectLogo} width={32} height={32} />
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          minWidth: 0,
        }}
      >
        <ProjectInfo onClick={onProjectClick} project={project} />
      </div>
      <div
        style={{
          alignSelf: 'center',
          flexGrow: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {embedPwWebComponent(serviceName) && AuthService.userIsAdmin(user) && (
          <LabeledToggle
            labelText='Default for connection'
            checked={tabIsDefault}
            onToggle={onSetDefaultConnection}
            labelStyles={{
              label: { alignItems: 'center', fontSize: 12 },
              span: { float: 'left', color: primaryTextColor(theme) },
              toggle: {
                marginLeft: '0',
                marginRight: '0',
                top: '1px',
                left: '-6px',
                transform: 'scale(0.5)',
              },
            }}
          />
        )}
      </div>
      {isElectron() && (
        <span
          style={{
            minWidth: '82px',
            fontSize: '12px',
            cursor: 'pointer',
            textDecoration: 'underline',
            flexShrink: 10,
            alignSelf: 'center',
            marginRight: '16px',
          }}
          onClick={() => setModalOpen(true)}
        >
          Notice about file downloads
        </span>
      )}
      <div
        style={{ display: 'flex', alignItems: 'center', marginRight: '6px' }}
      >
        <UserIconMenu
          user={user}
          onShowUserMenu={() => setShowUserMenu(cur => !cur)}
          visibleUserMenu={showUserMenu}
          onSignoutClick={onSignoutClick}
          onViewProfileClick={onViewProfileClick}
        />
      </div>
      <Dialog
        hidden={!modalOpen}
        onDismiss={() => setModalOpen(false)}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Downloading in ProjectWise',
          styles: {
            title: { ...themedText(theme) } as IStyle,
          },
        }}
        modalProps={{
          isDarkOverlay: theme !== 'default',
          styles: {
            main: {
              minWidth: '450px !important',
              ...themedText(theme),
            } as IStyle,
          },
        }}
      >
        <p style={{ ...defaultFont }}>
          ProjectWise file downloads in the Teams desktop app are downloaded to
          the default download folder. This is not currently configurable.
        </p>
        <DialogFooter>
          <DefaultButton onClick={() => setModalOpen(false)} text='Close' />
        </DialogFooter>
      </Dialog>
    </div>
  );
}
